import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import {
    initialObvTileConfigState,
    ObvTileConfigState,
} from 'widgets/obvTile/store/config/ObvTileConfigState';
import { buildSymbolDependentRequestHelpers } from 'widgets/streaming/buildSymbolDependentRequestHelpers';

export interface ObvTileStreamRequest {
    symbol: string;
    symbology: string;
    bucketSize: number;
}

function toRequestUid(symbol: string, configState: ObvTileConfigState): string {
    const config = configState ?? initialObvTileConfigState;
    const { bucketSize } = config;
    return `obvChart-${symbol}|${bucketSize}`;
}

function requestToStreamKey(request: ObvTileStreamRequest): string {
    const { symbol, bucketSize } = request;
    return toRequestUid(symbol, { bucketSize });
}

function buildRequest(
    symbol: string,
    symbology: SymbologyValues,
    configState: ObvTileConfigState
): ObvTileStreamRequest {
    const config = configState ?? initialObvTileConfigState;
    const { bucketSize } = config;
    return {
        symbol,
        symbology,
        bucketSize,
    };
}

const {
    createWidgetRequestUid,
    getWidgetStreamRequestInfo,
    getStreamRequestInfosForSymbols,
} = buildSymbolDependentRequestHelpers<
    ObvTileStreamRequest,
    ObvTileConfigState
>(toRequestUid, requestToStreamKey, buildRequest, initialObvTileConfigState);

export {
    createWidgetRequestUid as createObvTileRequestUid,
    getWidgetStreamRequestInfo as getObvStreamRequestInfo,
    getStreamRequestInfosForSymbols as getObvStreamRequestInfosForSymbols,
    toRequestUid as toObvRequestUid,
};
